import { Injectable } from '@angular/core';
import { StoreBase } from '../../shared/models/bases/storeBase';
import { BusinessProfessionalCount } from '../../shared/models/business';

@Injectable({providedIn: 'root'})
export class BusinessProfessionalCountStore extends StoreBase<BusinessProfessionalCount> { }
